<template>
  <div class="home py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.aerators.createPackage")}}</span>
    <div v-if="dataLoaded" class="form-container">
      <AveineAeratorPackageForm :APIbaseURL="APIbaseURL" :dfuPackage="dfuPackage" :hardwareVersions="hardwareVersions" :adminMode="true"/>
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular
        indeterminate
        :size="100"
        :width="10"
        color="secondary"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { AveineAeratorPackageForm } from 'aveine-aerator'
import { DfuPackage, HardwareVersion } from 'aveine-toolbox'
export default {
  data () {
    return {
      dfuPackage: {},
      hardwareVersions: [],
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  name: 'Create',
  components: {
    AveineAeratorPackageForm
  },
  async created() {
    this.dfuPackage = await DfuPackage.new();
    const that = this
    let reqHarwareVersion = await HardwareVersion.api().get(`hardware-versions`);
    reqHarwareVersion.response.data.map(async function(data){
      const hardware = await HardwareVersion.query().whereId(data.id).withAllRecursive().first();
      that.hardwareVersions.push({label: `${hardware.model}/${hardware.version}`, value: hardware});
    })
    this.dfuPackage.$isNew = true;
    this.dataLoaded = true;
  },
}
</script>
